export default function ({ route, redirect, req }) {
  const { url } = route.query;

  const ua = process.server
    ? req.headers['user-agent']
    : navigator.userAgent;
    
  if (ua.toLowerCase().indexOf('micromessenger') === -1) {
    if (url) {
      // 獲取當前頁面的 origin 和完整 URL
      const currentOrigin = process.server
          ? `${req.headers['x-forwarded-proto'] || 'https'}://${req.headers['host']}`
          : window.location.origin;
      // 獲取當前頁面的完整 URL 作為 Referer
      const referer = process.server
        ? `${req.headers['host']}${route.fullPath}`
        : window.location.href;

      // 將 Referer 附加到目標 URL 的查詢參數中
      const redirectUrl = new URL(url, currentOrigin);
      redirectUrl.searchParams.set('referer', encodeURIComponent('https://betapos.game-853.com'));
      console.log(redirectUrl);
      
      // 執行重定向
      redirect(redirectUrl.toString());
    }
  }

}
